import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

window.tourAudioPlayed = false;

const TourAudio = () => {
  const audioRef = useRef();
  const { featuredMedia } = useSelector((state) => state.json);
  const enabled = useSelector((state) => state.audio.enabled);
  const autoPlay = useSelector((state) => state.audio.autoPlay);
  const isOpenPopUp = useSelector((state) => state.isOpenPopUp);

  useEffect(() => {
    const audioSoundUrl = featuredMedia?.audio?.soundUrl || '';
    if (enabled && audioSoundUrl) {
      audioRef.current.src = audioSoundUrl;
      if (autoPlay) {
        audioRef.current.play();
        window.tourAudioPlayed = true;
      } else {
        audioRef.current.pause();
      }
    } else {
      audioRef.current.src = '';
    }
  }, [autoPlay, enabled, featuredMedia, isOpenPopUp]);

  return (
    <audio
      ref={audioRef}
      id="tourAudio"
      autoPlay={autoPlay}
      loop={true}
    ></audio>
  );
};

export default TourAudio;
